import {
  ApiAttributionModel,
  ApiChartAttribute,
  ApiDimension,
  ApiMetric,
} from "@incendium/api";
import { IStatCardProps } from "Components/UI/StatCard";
import { IChart, TChartData } from "Interfaces";
import { IFromToChartOutput } from "Providers/FromToProvider";
import { ReactNode, type JSX } from "react";

export type TDimensionMetricMap = {
  name?: string;
  description?: string;
  format?: (val: unknown, currency?: string, options?: { isKM?: boolean }) => string;
  excludedDimensions?: ApiDimension[]; // list of dimensions this metric is not compatible with (empty means none)
  compatibleDimensions?: ApiDimension[]; // list of dimensions this metric is compatible with (empty means none)
  attribtionType?: ApiAttributionModel;
  attribtionMetric?: AttributionMetric;
  plural?: string;
};

export interface IAnalyticsStatCardProps extends IStatCardProps {
  chart: IChart;
  renderBody: (
    data: TChartData[],
    comp?: TChartData[],
    trendData?: TChartData[]
  ) => ReactNode;
  setDirection?: (data: TChartData[], comp?: TChartData[]) => "up" | "down";
  chartOutput?: IFromToChartOutput;
  overrideComparisonOutput?: IFromToChartOutput;
  /** When set, skips the analytics fetch and uses this data instead. */
  overrideData?: TChartData[];
  overrideComparisonData?: TChartData[];
  includeTrendedSpark?: boolean;
  noBg?: boolean;
  forceComparison?: boolean;
}

export enum AttributionMetric {
  REVENUE = "revenue",
  PROFIT = "profit",
  NET_REVENUE = "net_revenue",
  SALES = "sales",
  MACRO = "macro",
  MACRO_RATE = "macro_rate",
  LTV = "ltv",
  ROAS = "roas",
  ROASLTV = "roasltv",
  ROI = "roi",
  ROILTV = "roiltv",
  CUMULATIVE_LTV = "cumulitiveltv",
  CUMULATIVE_LTV_PROFIT = "cumulitiveltvProfit",
  NEW_CUSTOMER = "customer",
  CAC = "cac",
  AOV = "aov",
}

export interface ICompare {
  direction?: "up" | "down" | "same";
  value?: number; // value change
  formatedValue?: string; // original value
}

export interface IOnClickMap {
  text: string;
  fn: (firstDimension?: string, filters?: ApiChartAttribute[]) => void;
  icon?: ReactNode;
}

export interface ITreeMapChartData {
  name: string;
  children: {
    name: string | null;
    metric: number;
    diff?: number;
  }[];
}

export type TTableCustomCellRender = {
  [K in ApiDimension | ApiMetric | string]?: (props: any) => JSX.Element;
};
